import React from 'react';
import {
    SimpleForm, TextInput, NumberInput, BooleanInput, SelectInput, required, FormDataConsumer,
} from 'react-admin';

import SupplyCategoryInput from '../controls/SupplyCategoryInput';
import SOFT_GOODS from '../controls/softGoods';

/**
 * Which lot field on the Phlebotomy tab this type feeds. More than one type
 * can point at the same field (two bottle vendors, say), and leaving it blank
 * keeps the type off the donation screen entirely.
 */
const phleboFieldChoices = SOFT_GOODS.map(item => ({
    id: item.field,
    name: 'Lot #: ' + item.label,
}));

/** Shared body for the supply type create and edit screens. */
const SupplyTypeForm = props => (
    <SimpleForm
        {...props}
        initialValues={{
            requires_qa: true,
            has_sublots: false,
            status: true,
            uom: 'EA',
            reorder_point: 0,
            expiry_warn_days: 30,
        }}
    >
        <SupplyCategoryInput validate={required()} />
        <TextInput source="name" label="Name" validate={required()} />
        <TextInput source="code" label="Code" />
        <TextInput source="uom" label="Unit of Measure" validate={required()} />
        <BooleanInput source="requires_qa" label="Receipts go through QA" />
        <BooleanInput source="has_sublots" label="Track sublots (open vials)" />

        <FormDataConsumer>
            {({ formData, ...rest }) =>
                formData.has_sublots ? (
                    <div>
                        <NumberInput source="sublot_size" label="Units per Sublot" {...rest} />
                        <NumberInput
                            source="open_expiry_days"
                            label="Open-vial Shelf Life (days)"
                            {...rest}
                        />
                    </div>
                ) : null
            }
        </FormDataConsumer>

        {/* Only donation softgoods are recorded per donation, so the field
            picker is hidden for calibration supplies. */}
        <FormDataConsumer>
            {({ formData, ...rest }) =>
                Number(formData.category_id) === 1 ? (
                    <SelectInput
                        source="phlebo_field"
                        label="Phlebotomy Lot Field"
                        choices={phleboFieldChoices}
                        helperText="Which lot number box on the Phlebotomy tab offers this supply's lots. Leave blank to keep it off the donation screen."
                        allowEmpty
                        emptyText="- not recorded per donation -"
                        {...rest}
                    />
                ) : null
            }
        </FormDataConsumer>

        <NumberInput source="reorder_point" label="Reorder Point (low-stock alert)" />
        <NumberInput source="expiry_warn_days" label="Expiry Warning (days)" />
        <BooleanInput source="status" label="Is Active?" />
    </SimpleForm>
);

export default SupplyTypeForm;
